const IDLE_TIMEOUT_MS = 15 * 60 * 1000;
const CHECK_INTERVAL_MS = 10 * 1000;

let lastActivity = Date.now();
let authCompleted = false;
let onLogout = null;
let checkIntervalId = null;

const isIdleExpired = () => Date.now() - lastActivity > IDLE_TIMEOUT_MS;

const recordActivity = () => {
  lastActivity = Date.now();
};

const logout = () => {
  authCompleted = false;
  onLogout?.();
};

const checkIdle = () => {
  if (!authCompleted) return;
  if (isIdleExpired()) {
    logout();
  }
};

export const onUserInteraction = () => {
  if (!authCompleted) return;
  if (isIdleExpired()) {
    logout();
    return;
  }
  recordActivity();
};

const onVisibilityChange = () => {
  if (document.visibilityState === 'visible') {
    checkIdle();
  }
};

const ACTIVITY_EVENTS = ['mousedown', 'keydown', 'touchstart', 'wheel'];

export const initInactivityService = (handleLogout) => {
  onLogout = handleLogout;

  ACTIVITY_EVENTS.forEach((event) =>
    document.addEventListener(event, onUserInteraction, { passive: true })
  );
  document.addEventListener('visibilitychange', onVisibilityChange);

  checkIntervalId = window.setInterval(checkIdle, CHECK_INTERVAL_MS);

  return () => {
    ACTIVITY_EVENTS.forEach((event) =>
      document.removeEventListener(event, onUserInteraction)
    );
    document.removeEventListener('visibilitychange', onVisibilityChange);
    if (checkIntervalId) window.clearInterval(checkIntervalId);
  };
};

export const markAuthCompleted = () => {
  authCompleted = true;
  recordActivity();
};

export const markAuthEnded = () => {
  authCompleted = false;
};
